// NotificationsContext.js
// ─────────────────────────────────────────────────────────────────────────────
// Zentrale Notification-State-Verwaltung für die gesamte App.
//
// PROBLEM das dieser Context löst:
//   useNotifications() öffnet eine SSE-Verbindung pro Mount.
//   Vorher wurde der Hook in Dashboard, MyCourses, Profile, BottomNavigation
//   und GlobalLayout je separat aufgerufen → 4-5 parallele SSE-Verbindungen
//   → gegenseitige Cancels → errorCount läuft auf 3 → Polling-Fallback →
//   kein Live-Toast für element_pending_approval.
//
// LÖSUNG:
//   NotificationsProvider hält genau EINE useNotifications()-Instanz.
//   Alle Komponenten lesen via useNotificationsContext() daraus —
//   keine eigene Hook-Instanz, keine eigene SSE-Verbindung.
//
// Usage:
//   // In App.js (einmalig):
//   <NotificationsProvider><AppContent /></NotificationsProvider>
//
//   // In jeder Komponente statt useNotifications():
//   const { notifications, dismissOne, dismissAll } = useNotificationsContext();

import React, { createContext, useContext } from 'react';
import useNotifications from './useNotifications';

const NotificationsContext = createContext(null);

/**
 * Einmalig im App-Baum mounten (direkt unter AuthProvider, vor Router-Content).
 * Hält die einzige SSE-Verbindung der gesamten App.
 */
export function NotificationsProvider({ children }) {
  const value = useNotifications();
  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}

/**
 * In allen Komponenten statt useNotifications() verwenden.
 * Gibt { notifications, dismissOne, dismissAll, refresh } zurück.
 */
export function useNotificationsContext() {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error('useNotificationsContext must be used inside NotificationsProvider');
  }
  return ctx;
}
